<template>
    <v-card>
        <v-card-text class="p-relative">
            <v-layout row wrap>
                <v-flex xs12>
                    <v-text-field
                        v-show="editMode || !sponsorshipId"
                        label="Titulo"
                        color="green"
                        v-model="form.title"
                        @input="onFormChange"
                        :rules="rules.required"
                        ref="title"
                        required>
                    </v-text-field>
                </v-flex>
                <v-flex xs12 sm12 v-show="!editMode && sponsorshipId">
                    <p><strong>Titulo:</strong> {{ form.title }}</p>
                </v-flex>
                <v-flex xs12 v-if="lang === 'es'">
                    <v-btn
                        color="success"
                        @click="addContent">Agregar contenido</v-btn>
                </v-flex>
                <v-flex xs12 v-if="lang === 'en'" class="add-content-height"></v-flex>
                <template v-for="( item, i ) in addedContents">
                    <v-flex xs12 sm10 :key="i" class="mt-4">
                        <p>Contenido {{ i + 1 }}</p>
                    </v-flex>
                    <v-flex xs12 sm1>
                        <v-btn
                            v-show="!contentsMode[i] && sponsorshipId && lang === 'es'"
                            @click="deleteContent( i )"
                            dark
                            flat
                            icon
                            color="red">
                            <v-icon dark>delete</v-icon>
                        </v-btn>
                    </v-flex>    
                    <v-flex xs12 sm1>
                        <v-btn
                            v-show="!contentsMode[i] && sponsorshipId"
                            @click="changeContentMode( i )"
                            dark
                            flat
                            icon
                            color="green">
                            <v-icon dark>edit</v-icon>
                        </v-btn>
                    </v-flex>      
                    <div v-show="contentsMode[i] || !sponsorshipId">    
                        <v-flex xs12 :key="i + 'check'">
                            <v-radio-group
                                v-model="addedContents[i].content_type"
                                @change="onContentTypeChange( i )"
                                v-if="lang === 'es'"
                                row>
                                <v-radio label="Texto" value="text"></v-radio>
                                <v-radio label="Multimedia" value="multimedia"></v-radio>
                            </v-radio-group>
                        </v-flex>
                        <v-flex xs12 v-show="addedContents[i].content_type === 'text'" :key="i + 'text'"
                            v-bind:class="{ 'content-radio-margin': lang === 'en' }">
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <ckeditor
                                        :editor="editor"
                                        v-model="addedContents[i].text"
                                        :config="editorConfig"
                                        @input="onFormChange"></ckeditor>
                                    <span
                                        class="custom-error"
                                        v-show="showContentsErrors && addedContents[i].text === ''">Este campo es obligatorio</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 v-show="addedContents[i].content_type === 'multimedia'" :key="i + 'multimedia'">
                            <v-layout row wrap>
                                <!-- <div v-show="contentsMode[i] || !sponsorshipId"> -->
                                    <v-flex xs12 v-show="contentsMode[i] || !sponsorshipId">
                                        <v-text-field
                                            label="Acción imagen"
                                            color="green"
                                            v-model="addedContents[i].action"
                                            ref="action"
                                            type="url"
                                            @input="onFormChange">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 v-show="contentsMode[i] || !sponsorshipId">
                                        <v-radio-group v-model="addedContents[i].media_type" row>
                                            <v-radio label="Imagen" value="image"></v-radio>
                                            <v-radio label="Video" value="video"></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                    <v-flex xs12 v-show="contentsMode[i] || !sponsorshipId">
                                        <v-btn color="info" @click="openFileChooser(i)">
                                            Subir {{ addedContents[i].media_type === 'image' ? 'imagen' : 'video' }}
                                            <v-icon right dark>cloud_upload</v-icon>
                                        </v-btn>
                                        <span
                                            class="custom-error"
                                            v-show="showContentsErrors && addedContents[ i ].file === null">Este campo es obligatorio</span>
                                        <InputFile ref="inputFile" :extensions="permittedExtensions(i)" @fileChange="fileChange" :pos="i"></InputFile>
                                    </v-flex>
                                    <v-flex xs12 v-show="contentsMode[i] || !sponsorshipId">
                                        <v-card-media
                                            :src="addedContents[i].image"
                                            height="200px"
                                            contain
                                            ></v-card-media>
                                    </v-flex>
                                <!-- </div> -->
                            </v-layout>
                        </v-flex>
                    </div>
                    <template v-if="!contentsMode[i] && sponsorshipId">
                        <v-flex xs12 v-show="addedContents[i].content_type === 'text'">
                            <code>{{ addedContents[i].text }}</code>
                        </v-flex>
                        <v-flex xs12 v-show="addedContents[i].content_type === 'multimedia'">
                            <v-card-media
                                :src="addedContents[i].image"
                                height="200px"
                                contain
                                ></v-card-media>
                            <p mt-1><strong>Acción: </strong><a :href="addedContents[i].action">{{ addedContents[i].action }}</a></p>
                        </v-flex>
                    </template>
                    <v-flex xs12 d-flex align-right v-show="contentsMode[i]">
                        <v-btn small color="red" @click="cancelUpdateContent( i )">Cancelar</v-btn>
                        <v-btn small color="green" @click="updateContent( i )">Guardar</v-btn>
                    </v-flex>
                </template>
            </v-layout>
        </v-card-text>
        <add-content-section-modal
            :dialog="showAddContentModal"
            :sectionPos="sectionPos"
            @close="showAddContentModal = false"></add-content-section-modal>
    </v-card>
</template>

<script>
    import Vue from 'vue'
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import InputFile from '@/components/helpers/InputFile';
    import AddContentSectionModal from './addContentSectionModal';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'ContentCard',
        props: {
            lang: {
                type: String,
                required: true
            },
            sectionPos: {
                type: Number,
                required: true
            },
            editMode: {
                type: Boolean,
                default: false
            },
            numberOfContents: 0
        },
        components: {
            InputFile,
            AddContentSectionModal
        },
        data() {
            return {
                showAddContentModal: false,
                contentsMode: [],
                sponsorshipId: null,
                inputFileOrderList: [],
                addedContents: [],
                showContentsErrors: false,
                requiredFields: [
                    'title',
                    'text'
                ],
                editor: ClassicEditor,
                editorConfig: {
                    toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote' ],
                },
                form: {
                    lang: this.lang,
                    title: '',
                    position: this.lang === 'en' ? 0 : 1,
                    /* text: '',
                    media_type: 'imagen',
                    file: null,
                    action: '' */
                },
                image: '',
                rules: {
                    required: [
                        val => {

                            let res = ((val === 0 ? '0' : String(val)) || '').length > 0 || 'Este campo es obligatorio'
                            return res
                        }
                    ]
                }
            }
        },
        created() {

            this.sponsorshipId = this.$route.params.id;
            this.initializeEditMode();
        },
        computed: {
            ...mapGetters([
                'currentSponsorship'
            ])
        },
        watch: {
            numberOfContents( newVal, oldVal ) {
                
                if ( newVal && this.lang === 'en' ) {
                    this.addedContents.push({
                        content_type: 'text',
                        text: '',
                        media_type: 'image',
                        file: null,
                        action: '',
                        image: null,
                        inputFileRefPos: null,
                        content_required_fields: [
                            'text'
                        ]
                    });
                }
            },
            currentSponsorship( newVal, oldVal ) {
                
                this.initializeEditMode();
            }
        },
        methods: {
            ...mapActions([
                'editSectionContent',
                'deleteSectionContent',
                'loadSponsorship'
            ]),
            initializeEditMode() {
                if ( this.currentSponsorship.id ) {

                    this.contentsMode = [];
                    this.form.title = this.currentSponsorship.sections[ this.sectionPos ][ `title_${ this.lang }` ];
                    this.addedContents = this.currentSponsorship.sections[ this.sectionPos ].contents.filter( item => item.lang === this.lang ).map( content => {
                        
                        this.contentsMode.push(false);

                        return { 
                            ...content,
                            content_type: content.type === 'image' ? 'multimedia' : content.type,
                            media_type: 'image',
                            image: content.media,
                            lang: this.form.lang,
                            content_required_fields: [
                                'text'
                            ]
                        }
                    });

                    this.onFormChange();
                }
            },
            fileChange( img, imgFile, pos ) {

                this.addedContents[ pos ].image = img.src;
                // this.form.file = imgFile;
                this.addedContents[ pos ].file = imgFile;
                this.onFormChange();
            },
            openFileChooser( i ) {

                this.$refs.inputFile[i].open();
            },
            onFormChange( menu = null ) {

                if ( menu ) { this[ menu ] = false; }

                this.$emit( 'update', { sectionPos: this.sectionPos, form: this.form, addedContents: this.addedContents } );
            },
            hasErrors( checkContents = true ) {

                this.showContentsErrors = true;
                let hasError = false;

                if ( this.form.title === '' || this.form.title === null ) {
                    hasError = true;
                    this.$refs.title.validate( true );
                }

                if ( checkContents ) {

                    this.addedContents.forEach( content => {
                        
                        content.content_required_fields.forEach( key => {
                            
                            hasError = content[ key ] === null || content[ key ] === '' || hasError;

                            if ( key !== 'text' && key !== 'file' ) { this.$refs[ key ].validate( true ); }
                        });

                    });
                }

                return hasError;
            },
            addContent() {

                if ( !this.currentSponsorship.id ) {

                    this.addedContents.push({
                        content_type: 'text',
                        text: '',
                        media_type: 'image',
                        file: null,
                        action: '',
                        image: null,
                        inputFileRefPos: null,
                        content_required_fields: [
                            'text'
                        ]
                    });
    
                    this.$emit('onContentAdded', this.addedContents.length);
                } else {

                    this.showAddContentModal = true;
                }
            },
            permittedExtensions( i ) {
                
                return this.addedContents[i].media_type === 'image'
                    ? 'image/x-png, image/jpeg'
                    : '.mp4';
            },
            onContentTypeChange( i ) {
                
                this.$emit('onContentPropertyChange', { 
                    key: 'content_type',
                    pos: i,
                    newValue: this.addedContents[ i ].content_type,
                    sectionPos: this.sectionPos
                 });

                this.addedContents[ i ].content_required_fields =
                    this.addedContents[ i ].content_type === 'text'
                        ? [ 'text' ]
                        : [ 'file' ];
            },
            modifyContent( key, pos, newValue ) {

                this.addedContents[ pos ][ key ] = newValue;
                this.onContentTypeChange( pos );
            },
            changeContentMode( i ) {

                Vue.set(this.contentsMode, i, !this.contentsMode[i]);
            },
            updateContent( i ) {

                this.addedContents[i].media = this.addedContents[i].file;
                delete this.addedContents[i].media_type;

                const data = {
                    ...this.addedContents[ i ]
                };
                delete data.content_required_fields;

                this.editSectionContent({
                    data,
                    callback: content => {
                        Vue.set(this.contentsMode, i, false);
                        Vue.set(this.addedContents, i, {
                            ...content,
                            id: this.addedContents[ i ].id,
                            content_required_fields: [
                                'text'
                            ]
                        });
                        this.addedContents[i].content_type = this.addedContents[i].type !== 'text' ? 'multimedia' : this.addedContents[i].type;
                    }
                });
            },
            cancelUpdateContent( i ) {

                this.addedContents[i].image = this.addedContents[i].media;
                delete this.addedContents[i].file;
                this.changeContentMode(i);
                this.addedContents[ i ].text = this.currentSponsorship.sections[ this.sectionPos ].contents.filter( item => item.lang === this.lang )[ i ].text || '';
            },
            deleteContent( i ) {
                
                const index = this.currentSponsorship.sections[0].contents.findIndex( content => content.id === this.addedContents[ i ].id);
                const esId = this.currentSponsorship.sections[0].contents[ index ].id;
                const enId = this.currentSponsorship.sections[0].contents[ index + 1 ].id;
                
                this.deleteSectionContent({
                    id: esId,
                    callback: () => this.deleteSectionContent({
                        id: enId,
                        callback: () => this.loadSponsorship({ id: this.$route.params.id })
                    })
                });
            }
        }

    }
</script>

<style>
    .custom-error {
        color: rgb(255, 82, 82);
        font-size: 12px;
    }

    .add-content-height {
        height: 56px;
    }

    .content-radio-margin {
        margin-top: 72px;
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/sponsorships/contentCard.vue